import { createAsyncThunk } from '@reduxjs/toolkit';

export const createBulkQrLabelCall = createAsyncThunk(
    'users/qrlabels/create-bulk',
    async (payload, thunkAPI,) => {

        const body = JSON.stringify(payload);
        console.log("body: " + JSON.stringify(body));


        try {
            const res = await fetch('/api/users/qrlabels/create-bulk', {
                method: 'POST',
                headers: {
                    Accept: 'application/JSON',
                    'Content-Type': 'application/json'
                },
                body,
            });

            const data = await res.json();

            if (res.status === 201) {
                return data;

            } else {
                console.log("createBulkQrLabelCall != 201 -----------------------");
                return thunkAPI.rejectWithValue(data);
            }

        } catch (err) {
            console.log("createBulkQrLabelCall Error -----------------------");
            console.log(err);
            return thunkAPI.rejectWithValue(err.response.data);
        }
    }
);